import { Outlet } from "react-router-dom";

const PatientComponent = () => {
  return (
    <div className="patient--layout">
      <Outlet />
    </div>
  );
};

export default PatientComponent;
